export const logLevelOptions = [
  { value: 'CRITICAL', label: 'Critical (for production)' },
  { value: 'ERROR', label: 'Error (for production)' },
  { value: 'WARNING', label: 'Warning (for development)' },
  { value: 'INFO', label: 'Info (for development)' },
  { value: 'DEBUG', label: 'Debug (for development)' },
];

export const CUSTOM_URL_VALUE = 'custom_url';

export const ambientSoundOptions: OptionType<string | null>[] = [
  { value: null, label: 'None' },
  { value: 'office_ambience', label: 'Office Ambience' },
  { value: 'city_ambience', label: 'City Ambience' },
  { value: 'forest_ambience', label: 'Forest Ambience' },
  { value: 'crowded_room', label: 'Crowded Room' },
  { value: 'hold_music', label: 'Hold Music' },
  { value: CUSTOM_URL_VALUE, label: 'Custom URL...' },
];

export const thinkingSoundOptions: OptionType<string | null>[] = [
  { value: null, label: 'None' },
  { value: 'keyboard_typing', label: 'Keyboard Typing' },
  { value: 'keyboard_typing2', label: 'Keyboard Typing (Variant)' },
  { value: CUSTOM_URL_VALUE, label: 'Custom URL...' },
];

export const backgroundAudioVolumeStepOptions = [
  '0',
  '0.1',
  '0.2',
  '0.3',
  '0.4',
  '0.5',
  '0.6',
  '0.7',
  '0.8',
  '0.9',
  '1.0',
];
